import { ReactSVG } from "react-svg";
import BuildingIcon from "../../../assets/images/Building.svg";
import Clock from "../../../assets/images/clock.svg";
import BOA from "../../../assets/images/Boa.svg";
import Freezing from "../../../assets/images/Freezing.svg";
import Unfreezing from "../../../assets/images/Unfreezing.svg";
import Bars from "../../../assets/images/bars.svg";
import Calendar from "../../../assets/images/calendar.svg";
import Setting from "../../../assets/images/setting.svg";
import React from "react";
import { useTranslation } from "react-i18next";

const MobileMenu = ({ activeTab, redirectToPage }) => {
  const { t } = useTranslation();
  return (
    <ul className="navbar-nav mr-auto">
      <li
        className={activeTab === "overview" ? "active" : ""}
        onClick={() => redirectToPage("overview")}
      >
        <ReactSVG src={BuildingIcon} />
        <span>{t("Overview")}</span>
      </li>
      <li
        className={activeTab === "transactions-history" ? "active" : ""}
        onClick={() => redirectToPage("transactions-history")}
      >
        <ReactSVG src={Clock} />
        <span>{t("Transaction_History")}</span>
      </li>
      <li
        className={activeTab === "send-boa" ? "active" : ""}
        onClick={() => redirectToPage("send-boa")}
      >
        <ReactSVG src={BOA} />
        <span>{t("Send_BOA")}</span>
      </li>
      <li
        className={activeTab === "create-validator" ? "active" : ""}
        onClick={() => redirectToPage("create-validator")}
      >
        <ReactSVG src={Freezing} />
        <span>{t("Create_Validator")}</span>
      </li>
      <li
        className={activeTab === "unfreezing" ? "active" : ""}
        onClick={() => redirectToPage("unfreezing")}
      >
        <ReactSVG src={Unfreezing} />
        <span>{t("Unfreezing")}</span>
      </li>
      <li
        className={activeTab === "store-data" ? "active" : ""}
        onClick={() => redirectToPage("store-data")}
      >
        <ReactSVG src={Bars} />
        <span>{t("Store_Data")}</span>
      </li>
      <li
        className={activeTab === "contact-list" ? "active" : ""}
        onClick={() => redirectToPage("contact-list")}
      >
        <ReactSVG src={Calendar} />
        <span>{t("Contact_List")}</span>
      </li>
      <li
        className={activeTab === "settings" ? "active" : ""}
        onClick={() => redirectToPage("settings")}
      >
        <ReactSVG src={Setting} />
        <span>{t("Settings")}</span>
      </li>
    </ul>
  );
};
export default React.memo(MobileMenu);
